import React from "react";

export default function About(props) {
    return (
        <div className="mainfunc-block">
            <section>
                <h2>
                    What is this project?
                </h2>
                <p>
                    This site is a redesign for UW's current MyPlan registration system. It includes the Schedule Builder Page and the Search Page.
                </p>
            </section>  
            <section>
                <h2>
                    Why this project?
                </h2>
                <p>
                    At school, we actually have a lot of resources about course information, course details, and past archives about the class. However, in the current MyPlan system, sometimes it is hard to find the class you need, and everyone have the exhausting experience of trying to fit different sections from different classes together.
                    This annoying situation could have been better with a redesign of the current system, and that's why I started this project.
                </p>
            </section>  
            <section>
                <h2>
                    What is changed here?
                </h2>
                <p>
                    Overall, I'm making the system more "Plan-Based". 
                    I want students to start with an empty plan, and they can add classes to the plan as they search. 
                    Different plans can contain different courses to better fit the need for students still exploring their area of interest. 
                    Last quarter when I'm swaying between two minors, I had a hard time managing mt courses because all the classes are mixed in the schedule. I cannot make two "Paths" based on my plan. 
                    Now with the redesign, students in similar situations could easily handle their schedules.
                </p>
                
                <img className="img img-wide" src="img/search-new.png" alt="the new search interface"/>
                <p>
                    In the search page, I redesigned the way course result is shown from compact list to cards. 
                    Doing this will result in a cleaner and more modern-looking interface. I also planned to change what content is displayed in each card to better fit student's needs.
                </p>
                <p>
                    I'm planning to add more interactivity into the schedule builder page, and probably make it the main page, because it is a really useful function but in my survey, many student rarely use it. And some never used it!
                    I want to make the classes cards-like on the calendar, and students can pick, drag, and drop to edit their schedule. This will be more intuitive than the current schedule builder.
                </p>
                <img className="img img-wide" src="img/schedule-builder.png" alt="the current schedule builder"/>
                <img className="img img-mid" src="img/plan-new.png" alt="the new plan management interface"/>
                <p>
                    In the two screenshots above, the current system's plan function can only be used as a way to switch between pre-generated schedules. 
                    In contrast, the redesigned system let students create, edit, and customize plans. 
                    This give students full control of their plans and thus better manage their schedules.
                </p>
            </section>
        </div>
    );
}